import { motion } from 'motion/react'
import { ReactNode, RefObject } from 'react'

export type SubtleLoaderProps = {
	delay?: number
	children?: ReactNode
	ref?: RefObject<HTMLDivElement | null>
	width?: number
}

export function SubtleLoader({ delay = 1, children, ref, width = 80 }: SubtleLoaderProps) {
	return (
		<motion.div
			ref={ref}
			initial={{
				opacity: 0,
				y: 10,
			}}
			animate={{
				opacity: 1,
				y: 0,
				transition: { duration: 0.2, delay },
			}}
			exit={{
				opacity: 0,
				y: -10,
				filter: 'blur(3px)',
				transition: { duration: 0.3 },
			}}
			className="flex flex-col justify-center items-center gap-4 mx-auto"
		>
			<div className="h-1 bg-brand-100 rounded-full ring-white ring-1" style={{ width }}>
				<motion.div
					initial={{ width: 0 }}
					animate={{ width: '96%' }}
					transition={{ duration: 2.5, delay: delay - 0.15 }}
					exit={{
						width: '100%',
						transition: { duration: 0.5 },
					}}
					className="h-1 bg-brand-300 rounded-full"
				/>
			</div>
			{children ? <div className="text-xs text-brand-500 animate-pulse">{children}</div> : null}
		</motion.div>
	)
}
